const DriverAccountConfig = [
  {
    id: Math.random() * 10,
    name: "section",
    fields: [
      {
        id: Math.random() * 10,
        name: "Name",
        label: "Name (As in Aadhar)",
        FirstCharCap: true,
        type: "text",
      },
      {
        id: Math.random() * 10,
        name: "Company_Name",
        label: "Company_Name",
        type: "text",
      },

      {
        id: Math.random() * 10,
        name: "Residential_Address",
        label: "Residential Address",
        type: "textarea",
        FirstCharCap: true,
      },
      {
        id: Math.random() * 10,
        name: "Residential_Pincode",
        type: "number",
        min: 6,
        max: 6,
        ValidationType: "VALID_NUMBER",
      },
      {
        id: Math.random() * 10,
        name: "Sidebyside",
        Subfields: [
          {
            id: Math.random() * 10,
            name: "Residential_City",
            label: "City",
            setvalue: "City",
            disable: true,
            type: "text",
          },
          {
            id: Math.random() * 10,
            name: "Residential_State",
            label: "State",
            setvalue: "State",
            disable: true,
            type: "text",
          },
        ],
      },

      {
        id: Math.random() * 10,
        name: "Mobile_Number",
        label: "Mobile No",
        type: "number",
        min: 10,
        max: 10,
        ValidationType: "VALID_NUMBER",
      },
      {
        id: Math.random() * 10,
        name: "Emergency_Number",
        label: "Emergency Number",
        type: "number",
        min: 10,
        max: 10,
        ValidationType: "VALID_NUMBER",
      },
      {
        id: Math.random() * 10,
        name: "Aadhar_Number",
        label: "Aadhar Number",
        type: "inputMask",
        mask: "9999-9999-9999",
        min: 12,
        max: 12,
        ValidationType: "AADHAAR",
      },
      {
        id: Math.random() * 10,
        name: "Pan_Number",
        label: "Pan Number",
        type: "text",
        min: 10,
        max: 10,
        AllCaps: true,
        ValidationType: "PAN",
      },
      {
        id: Math.random() * 10,
        type: "text",
        label: "Police Station",
        name: "Police_Station",
        FirstCharCap: true,
      },

      {
        id: Math.random() * 10,
        name: "Licence_No",
        label: "Licence No",
        type: "text",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Valid_Up_To",
        label: "Valid Upto",
        type: "text",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        FirstCharCap: true,
        type: "text",
        name: "Notes",
      },
    ],
  },
  {
    name: "Other_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Upload Image",
        Imagefileds: [
          {
            id: Math.random() * 10,
            name: "Aadhar_Card",
            img: "img",
          },
          {
            id: Math.random() * 10,
            name: "Pan_Card",
            img: "img",
          },
          {
            id: Math.random() * 10,
            name: "Self_Photo",
            img: "img",
          },
          {
            id: Math.random() * 10,
            name: "Driving_License",
            img: "",
          },
          {
            id: Math.random() * 10,
            name: "Individual_Photo",
            img: "",
          },
          {
            id: Math.random() * 10,
            name: "Other_Doc_1",
            img: "",
          },
          {
            id: Math.random() * 10,
            name: "Other_Doc_2",
            img: "",
          },
        ],
      },
    ],
  },
];

const DriverAccountForMerge = [
  {
    id: Math.random() * 10,
    name: "Driver_Data",
    fields: [
      {
        id: Math.random() * 10,
        name: "Name",
        label: "Name (As in Aadhar)",
        type: "text",
        disabled: true,
      },
      {
        id: Math.random() * 10,
        name: "replace_with",
        label: "Relace With",
        masterName: "Driver_Account",
        type: "InputDropForQuery",
      },
    ],
  },
];

export const controlData = [
  {
    name: "Controls",
    fields: [
      {
        id: Math.random() * 10,
        name: "Is_Mobile_Verified",
        label: "Is Mobile Verified ",
        type: "checkbox",
        min: 0,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Is_Documents_Verified",
        label: "Is Documents Verified ",
        type: "checkbox",
        min: 0,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "KYC_Complete",
        label: "KYC Complete",
        type: "checkbox",
        min: 0,
        max: Infinity,
        disabled: false,
      },
      {
        id: Math.random() * 10,
        name: "Is_Verified",
        label: "Is Verified ",
        type: "checkbox",
        min: 0,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Is_Driving_License_Verified",
        label: "Is Driving License Verified",
        type: "checkbox",
        min: 0,
        max: Infinity,
        disabled: true,
      },
      {
        id: Math.random() * 10,
        name: "Is_Aadhar_Verified",
        label: "Is Aadhar Verified ",
        type: "checkbox",
        min: 0,
        max: Infinity,
        disabled: false,
      },
      {
        id: Math.random() * 10,
        name: "Is_Lock",
        label: "Is Lock",
        type: "checkbox",
        min: 0,
        max: Infinity,
        disabled: true,
      },
    ],
  },
];

export { DriverAccountConfig, DriverAccountForMerge };
